<template>
    <div class="project-date-choose">
        <sheet :show.sync="showSheet" title="Date" close>
            <div class="date-year">
                <svg-icon icon-class="arrow" @click.native="changeMonth(false)"></svg-icon>
                <div class="text">{{year}} {{monthStr[month].name}}</div>
                <svg-icon icon-class="arrow" @click.native="changeMonth(true)"></svg-icon>
            </div>
            <div class="date-weeks">
                <div class="text" v-for="i in weeksStr" :key="i.name">{{i.name}}</div>
            </div>
            <div class="date-days">
                <div class="text" :class="[{'active': day.isActive, 'isChose': isChose(day)}]" v-for="(day, index) in days" :key="index" @click="dayClick(day)">{{day.text}}</div>
            </div>
            <sd-button mini2 class="date-button" @click.native="confirm()">{{$t('text.confirm')}}</sd-button>
        </sheet>
    </div>
</template>

<script>
import sheet from "./sheet.vue";
import sdButton from "./button.vue";
import svgIcon from "../svgIcon.vue"

export default {
    name: "sd-date",
    components: { sheet, sdButton, svgIcon },
    props: {
        show: Boolean,
        weeks: Array,
        nochooseDays: Array
    },
    data() {
        return {
            showSheet: this.show,
            weeksStr: [{
                name: this.$t('text.MON')
            },{
                name: this.$t('text.TUE')
            },{
                name: this.$t('text.WED')
            },{
                name: this.$t('text.THU')
            },{
                name: this.$t('text.FRI')
            },{
                name: this.$t('text.SAT')
            },{
                name: this.$t('text.SUN')
            }],
            monthStr: [{
                name: this.$t('text.january')
            },{
                name: this.$t('text.february')
            },{
                name: this.$t('text.march')
            },{
                name: this.$t('text.april')
            },{
                name: this.$t('text.may')
            },{
                name: this.$t('text.june')
            },{
                name: this.$t('text.july')
            },{
                name: this.$t('text.august')
            },{
                name: this.$t('text.september')
            },{
                name: this.$t('text.october')
            },{
                name: this.$t('text.november')
            },{
                name: this.$t('text.december')
            }],

            year: 2022,
            month: 8,
            days: [],
            chooseDay: [],
        }
    },
    watch: {
        show(val) {
            this.showSheet = val
        },
        showSheet(val) {
            this.$emit('update:show', val)
        }
    },
    created() {
        this.getDate();
    },
    methods: {
        getDate() {
            let date = new Date()
            let year = date.getFullYear();//获取当前年份
            this.year = year;
            let month = date.getMonth();//获取当前月份
            this.month = month;
            // let sunday = date.getDate();//获取当前日

            this.getDays(year, month+1);
        },

        getDays(year, month) {
            let nochooseDays = this.nochooseDays || [];
            let dateNum = new Date(year, month, 0); //(可传入任意年份,月份)
            let timeNUm = dateNum.getDate(); //获取当前月有多少天
            let weekList = [7, 1, 2, 3, 4, 5, 6]
            let res = new Date(month + '/' + 1 + '/' + year); //(可传入任意年份,月份)
            let reNum = weekList[res.getDay()]; // 月份第一天是周几
            let res2 = new Date(month + '/' + timeNUm + '/' + year); //(可传入任意年份,月份)
            let reNum2 = weekList[res2.getDay()]; // 月份最后一天是周几


            let blank1 = [], blank2 = [], days = [];
            for(var i = 0; i < (reNum - 1); i++) {
                blank1.push(1)
            }for(var i = 0; i < (7 - reNum2); i++) {
                blank2.push(2)
            }for(var i = 0; i < timeNUm; i++) {
                days.push(3)
            }

            let thisDate = new Date();                //获取当前时间
            let thisYear = thisDate.getFullYear();    //获取当前年份
            let thisMonth = thisDate.getMonth() + 1;  //获取当前月份
            let thisDay = thisDate.getDate();         //获取当前日期是周几


            this.days = [
                ...blank1.map(item => {
                    return { text: "", isBlank: true }
                }),
                ...days.map((item, index) => {
                    let dayStr = index + 1;
                    let fulldayStr = year+'-'+(month>=10?month:'0'+month)+'-'+(dayStr>=10?dayStr:'0'+dayStr);
                    let active = false;
                    if(nochooseDays.includes(fulldayStr)) {
                        active = false
                    }else if(year > thisYear) {
                        active = true
                    }else if(year == thisYear && month > thisMonth) {
                        active = true
                    }else if(year< thisYear || month < thisMonth) {
                        active = false
                    }else if(dayStr >= thisDay) {
                        active = true
                    }
                    // if(nochooseDays.includes(fulldayStr)) {
                    //     active = false
                    // }else if(year > thisYear || month > thisMonth) {
                    //     active = true
                    // }else if(year< thisYear || month < thisMonth) {
                    //     active = false
                    // }else if(dayStr >= thisDay) {
                    //     active = true
                    // }
                    let dayWeek = parseInt((reNum+index)%7);
                    dayWeek = dayWeek == 0? 7 : dayWeek-1;
                    return { text: dayStr, isActive: (active && this.weeks.includes(dayWeek.toString())) }
                }),
                ...blank2.map(item => {
                    return { text: "", isBlank: true }
                })
            ];

        },

        isChose(day) {
            return (this.year == this.chooseDay[0] && (this.month + 1) == this.chooseDay[1] && day.text == this.chooseDay[2])
        },

        dayClick(day) {
            if(!day.isBlank && day.isActive) {
                this.chooseDay = [this.year, this.month + 1, day.text];
            }
        },

        changeMonth(isNext) {
            if(isNext) {
                if(this.month == 11) {
                    this.year++;
                    this.month = 0;
                }else {
                    this.month++;
                }
            }else {
                if(this.month == 0) {
                    this.year--;
                    this.month = 11;
                }else {
                    this.month--;
                }
            }
            this.getDays(this.year, this.month+1)
        },

        confirm() {
            if(!this.chooseDay.length) {
                return this.$utils.message(this, this.$t('text.please_select'))
            }
            this.$emit('confirm', this.chooseDay)
        }
    }
}
</script>

<style lang="scss" scoped>
.project-date-choose {
    /deep/ {
        .project-sheet  {

            .header .text {
                margin-left: 16px;
            }

            .sheet-content {
                padding-bottom: 24px;
            }
        }
    }

    .date-year {
        display: flex;
        height: 19px;
        align-content: center;
        justify-content: center;
        padding-top: 16px;
        padding-bottom: 8px;

        .arrow {
            top: 0.5px;
            width: 16px;
            height: 16px;
            color: #A3A9AF;
            position: relative;
            transform: rotate(90deg);

            &:last-child {
                transform: rotate(-90deg);
            }
        }

        .text {
            font-weight: bold;
            color: #E22F25;
            margin: 0 12px;
        }
    }

    .date-weeks {
        color: #A3A9AF;
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        height: 40px;
        margin: 0 17px;
        align-items: center;
        justify-content: space-between;

        .text {
            width: 100%;
            font-size: 11px;
            text-align: center;
        }
    }

    .date-days {
        color: #0D0E10;
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        flex-wrap: wrap;
        margin: 0 17px;
        margin-top: 10px;
        margin-right: 7px;
        align-items: center;

        .text {
            opacity: 0.19;
            width: 100%;
            height: 100%;
            line-height: 40px;
            font-size: 13px;
            text-align: center;
            // margin-right: 10px;
            // margin-bottom: 10px;
            border-radius: 50%;

            &.active {
                opacity: 1;
            }

            &.isChose {
                color: white;
                background-color: #E22F25;
            }
        }
    }

    .date-button {
        width: 327px;
        margin: 0 auto;
        margin-top: -4px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/date.vue